require('./hirePackOpenYoungSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

// @constants
const {
    PROC_CONTRACTS,
    PROC_OPEN_YOUNG_ATTACH_DOCUMENTATION,
    recordPath,
} = require('utilities/tagging');
const { OPENYOUNG_CARD_ACCIDENT_INSURANCE } = require('constants/links');
const { catalogue, analyticsId } = require('../analytics/hirePackOpenYoungAnalytics');

class HirePackOpenYoungSuccess extends React.Component {

    componentDidMount() {
        recordPath('adjuntar documentacion', '', PROC_OPEN_YOUNG_ATTACH_DOCUMENTATION, 'exito', 'tarjeta prepago open young');
    }

    buildUploadDocumentationSection() {
        const { immHirePackOpenYoung } = this.props;

        let uploadDocumentation;

        if (!!immHirePackOpenYoung.get('cardId')) {
            const addDocumentationLink = `/myprofile/cards/${immHirePackOpenYoung.get('cardId')}/upload-documentation`;

            uploadDocumentation = (
                <div className="hire-pack-open-young-success__upload-documentation-wrapper">
                    <p className="hire-pack-open-young-success__upload-documentation">
                        <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_uploadDocumentationText" />
                    </p>
                    <OKButton
                        modifier="secondary"
                        to={addDocumentationLink}
                    >
                        <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_uploadDocumentationButton" />
                    </OKButton>
                </div>
            );
        }

        return uploadDocumentation;
    }

    buildLegalRepresentatives() {
        const { immHireOpenYoungInterveners } = this.props;

        const interveners = immHireOpenYoungInterveners.get('list').map((immIntervener, index) => (
            <li
                className="hire-pack-open-young-success__list-item"
                key={index}
            >
                {immIntervener.get('name')}
            </li>
        ));

        return (
            <ul className="hire-pack-open-young-success__list-container">
                {interveners}
            </ul>
        );
    }

    buildSummary() {
        const {
            immAccount,
            immOpenYoungPersonalData,
        } = this.props;

        const accountIban = getLastNChars(immAccount.get('iban'));
        const minorName = immOpenYoungPersonalData.getIn(['name', 'value']);
        const minorLastName = immOpenYoungPersonalData.getIn(['lastName', 'value']);
        const minorLastName2 = immOpenYoungPersonalData.getIn(['lastName2', 'value']);
        const minorFullName = `${minorName} ${minorLastName} ${minorLastName2}`;
        const legalRepresentatives = this.buildLegalRepresentatives();

        return (
            <React.Fragment>
                <div className="row hire-pack-open-young-success__summary">
                    <div className="col-xs-6 hire-pack-open-young-success__summary-left-column">
                        <FormattedText
                            className="col-xs-12 hire-pack-open-young-success__summary-title"
                            value="hirePackOpenYoung-hirePackOpenYoung_successMinorName"
                        />
                        <div className="col-xs-12 hire-pack-open-young-success__summary-value">
                            {minorFullName}
                        </div>
                        <FormattedText
                            className="col-xs-12 hire-pack-open-young-success__summary-title"
                            value="hirePackOpenYoung-hirePackOpenYoung_successAssociatedAccount"
                        />
                        <div className="col-xs-12 hire-pack-open-young-success__summary-value">
                            {`${immAccount.get('alias')} ${accountIban}`}
                        </div>
                    </div>
                    <div className="col-xs-5 col-xs-offset-1">
                        <FormattedText
                            className="col-xs-12 hire-pack-open-young-success__summary-title"
                            value="hirePackOpenYoung-hirePackOpenYoung_successIntervenerLegalRepresentative"
                        />
                        <div className="col-xs-12 hire-pack-open-young-success__summary-value">
                            {legalRepresentatives}
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="hire-pack-open-young-success__download-instruction">
                            <FormattedText
                                value="contractsView-openyoungAppDownloadInfo"
                                className="hire-pack-open-young-success__title"
                                injectedStrings={[minorFullName]}
                            />
                        </div>
                        <div className="hire-pack-open-young-success__text-message">
                            <OKMessage type="informative">
                                <FormattedText value="contractsView-openyoungDocumentFirst" />
                            </OKMessage>
                        </div>
                        <div className="hire-pack-open-young-success__text-message">
                            <OKMessage type="informative">
                                <OKLink
                                    to={OPENYOUNG_CARD_ACCIDENT_INSURANCE}
                                    target="_blank"
                                    modifier="inline"
                                    >
                                    <FormattedText value="contractsView-openyoungDocumentSecond" />
                                </OKLink>
                            </OKMessage>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    buildTexts() {
        const { immShippingAddress } = this.props;
        const address = PersonalDataHelper.getHireFormattedAddress(immShippingAddress);
        const titleKey = 'hirePackOpenYoung-hirePackOpenYoung_successTitleCompleted';
        const uploadDocumentation = this.buildUploadDocumentationSection();
        const textElement = (
            <div className="col-xs-8 hire-pack-open-young-success__text">
                {uploadDocumentation}
                <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successText1Completed" />
                <div className="hire-pack-open-young-success__address">
                    <i className="hire-pack-open-young-success__address-icon icon icon-s-locacion" />
                    {address}
                </div>
                <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successText2Completed" />
            </div>
        );

        return {
            textElement,
            titleKey
        };
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const url = formatText('hirePackOpenYoung-hirePackOpenYoung_successWarningUrl');
        const text = !!email ? 'hirePackOpenYoung-hirePackOpenYoung_successWarningTextSentByEmail' : 'hirePackOpenYoung-hirePackOpenYoung_successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="col-xs-12">
                <OKMessage type="informative">
                    <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successWarningText1" />
                    &nbsp;
                    <OKLink
                        modifier="emphasize"
                        target="_blank"
                        to={url}
                    >
                        <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successWarningText2" />
                    </OKLink>
                    &nbsp;
                    <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successWarningText3" />
                    <FormattedText
                        className="hire-pack-open-young-success__message-block"
                        injectedStrings={injectedString}
                        value={text}
                    />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immProfile,
            processDetail
        } = this.props;

        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const { textElement, titleKey } = this.buildTexts();
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hirePackOpenYoung-hirePackOpenYoung_successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };

            content = (
                <WizardSuccess
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    processType={PROC_CONTRACTS}
                    successMessage={formatText(titleKey)}
                    tealium={catalogue[analyticsId.OPEN_YOUNG_PACK_WIZARD_SUCCESS]({ productName: processDetail })}
                    isSecondVersion
                >
                    <article className="hire-pack-open-young-success">
                        <p className="hire-pack-open-young-success__subtitle">
                            <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successSubtitle1" />
                            &nbsp;
                            <span className="hire-pack-open-young-success__text-highlight">+</span>
                            &nbsp;
                            <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successSubtitle2" />
                        </p>
                        <p className="hire-pack-open-young-success__text hire-pack-open-young-success__text--margin-bottom">
                            <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successReminder" />
                        </p>
                        <p className="hire-pack-open-young-success__text hire-pack-open-young-success__text--margin-bottom">
                            <FormattedText value="hirePackOpenYoung-hirePackOpenYoung_successCardBlock" />
                        </p>
                        <div className="row hire-pack-open-young-success__summary-card-row">
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-pack-open-young-success__card-image"
                                immImageData={immImageData}
                            />
                            {textElement}
                        </div>
                        {summarySection}
                        <div className="row hire-pack-open-young-success__message">
                            {messageSection}
                        </div>
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

HirePackOpenYoungSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHirePackOpenYoung: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    immHireOpenYoungInterveners: PropTypes.object.isRequired,
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    processDetail: PropTypes.string
};

module.exports = HirePackOpenYoungSuccess;
